export function isLongText(element: HTMLElement): boolean {
	const { scrollHeight, clientHeight } = element;
	return scrollHeight > clientHeight;
}
